import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store/index.js'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: '首页',
    component: () => import('@/views/Home.vue'),
    // children: [
    //   { path: '', name: '首页', component: () => import('@/views/profile/Index.vue')}
    // ]
  },
  {
    path: '/blank',
    name: '空白',
    component: () => import('@/views/Home.vue'),
    children: [
      { path: '', name: '空白页', component: () => import('@/views/profile/Blank.vue')}
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.fullPath == '/login') {
    let currRoutes = store.getters.routes || [];
    currRoutes.forEach(r => router.removeRoute(r.name));

    store.dispatch('removeAll');
    next();
    return;
  }

  store.commit('checkToken');
  if (!store.getters.userId || store.getters.userId == 'undefined') {
    next({path: '/login'});
    return;
  }

  if (to.path == '/blank') {
    next();
    return;
  }

  if (!store.getters.isGetMenu) {
    let currRoutes = store.getters.routes || [];
    currRoutes.forEach(r => router.removeRoute(r.name));

    store.dispatch('checkMenu').then(routes => {
      store.dispatch('checkOrgnizations')
      routes.forEach(r => router.addRoute(r));
      store.commit('isGetMenuTrue')
      const isFind = store.getters.powers.find(r => r.url == to.path);
      
      if (!isFind && routes.length) {
        next(getFirstSub(routes[0]).path)
      } else {
        next(to.fullPath)
      }
    }).catch(err => {
      console.error(err)
      next({path: '/'})
    })
  } else {
    next();
  }
  
});

/** 获取第一子孙路由 */
function getFirstSub(route) {
  if (route.children && route.children.length) {
    return getFirstSub(route.children[0]);
  }
  return route;
}

export default router
